import { Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { SimpleLayout } from 'src/layout';

interface ErrorProps {
  status?: number;
  title: string;
  description: string;
  actions?: React.ReactNode;
}

function Error({ status, title, description, actions }: ErrorProps) {
  return (
    <SimpleLayout>
      <Container
        maxWidth="sm"
        sx={{
          height: '100%',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack spacing={4} alignContent="center">
          {status && (
            <Typography
              sx={(theme) => ({ color: theme.palette.grey[200] })}
              fontSize="9.375rem"
              fontWeight={800}
            >
              {status}
            </Typography>
          )}
          <Stack spacing={3} alignItems="center">
            <Stack>
              <Typography variant="h6">{title}</Typography>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Stack>
            {actions || (
              <Button component={RouterLink} variant="contained" href="/" color="primary">
                Go to Home
              </Button>
            )}
          </Stack>
        </Stack>
      </Container>
    </SimpleLayout>
  );
}

export default Error;
